
import { mapGetters, mapActions } from 'vuex'
import PdpBreadcrumb from './pdp-breadcrumb'
import PdpGallery from './pdp-gallery'
import PdpBuybox from './pdp-buybox'
import PdpFeatures from './pdp-features'
import PdpBundles from './pdp-bundles'
import PdpProductCallouts from './pdp-product-callouts'
import PdpDescription from './pdp-description'
// import PdpIGPhotos from './pdp-igphotos'
import PdpReviews from './pdp-reviews'
import RecentlyViewed from '~/components/common/lole-recently-viewed'
import { parseBreadcrumbs } from '~/helpers/shopify/breadcrumbs'
import { parseWidget } from '~/helpers/reviews/parseReviewsWidget'
export default {
  components: {
    PdpBreadcrumb,
    PdpGallery,
    PdpBuybox,
    PdpFeatures,
    PdpBundles,
    PdpProductCallouts,
    PdpDescription,
    // PdpIGPhotos,
    PdpReviews,
    RecentlyViewed,
  },
  provide() {
    return {
      product: this.product,
      wording: this.wording,
      // wordingInstagram: this.wordingInstagram,
      wordingCallouts: this.wordingCallouts,
    }
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
    // wordingInstagram: {
    //   type: Object,
    //   required: true,
    // },
    wordingCallouts: {
      type: Object,
      required: true,
    },
    wordingBundles: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    showZoom: false,
    productId: null,
    selectedColor: null,
    variantId: null,
    verticalScroll: 0,
    reviews: {},
    reviewsResults: [],
    reviewsBreakdown: [],
    reviewsPerPage: 10,
    reviewPage: 1,
    reviewsSortBy: 'date_desc',
    pageBreadcrumbs: [],
    showCarousels: false,
  }),
  computed: {
    ...mapGetters({
      vxBreadcrumbs: 'common/getBreadcrumbs',
      vxModelGroups: 'common/getModelGroups',
      vxCurrency: 'currency/getCurrency',
    }),
    paginatedReviews() {
      return this.reviewsResults.slice(
        0,
        (this.reviewsPerPage + 1) * this.reviewPage
      )
    },
    totalPages() {
      return Math.max(this.reviewsResults.length / this.reviewsPerPage)
    },
    productSlug() {
      return this.$route.params.slug
    },
  },
  async mounted() {
    window.addEventListener('scroll', this.scrollY)
    this.vxAddRecentlyViewedProduct(this.product)

    // REVIEWS
    await this.getProductReviews()

    // BREADCRUMBS
    if (this.vxBreadcrumbs) {
      this.pageBreadcrumbs = parseBreadcrumbs(
        this.product?.metafield?.breadcrumb,
        this.vxBreadcrumbs,
        this.$i18n.locale
      )
    }

    // SCROLL EVENT FOR LAZY LOADED CAROUSELS
    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll)
    }, 300)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      vxAddRecentlyViewedProduct:
        'recentlyViewedProducts/addRecentlyViewedProduct',
    }),
    async getProductReviews() {
      try {
        const ONE_DAY = 60 * 60 * 24
        const queryPromises = []
        const productReviewsHash = await this.$redisClient.getHashAll(
          `jdgme-reviews:${this.productSlug}`
        )

        for (const id of this.product.aggregatedIds) {
          if (id) {
            // PARSE PRODUCT ID & LOCALE
            const productId = id.split('/').pop()

            /**
             * REVIEWS
             */
            // IF DATA EXISTS IN HASH, ADD TO REVIEWS RESULTS
            if (productReviewsHash?.[productId]) {
              const reviewsResponseData =
                JSON.parse(productReviewsHash?.[productId]) || {}

              if (reviewsResponseData?.reviews)
                this.reviewsResults.push(...reviewsResponseData.reviews)

              if (reviewsResponseData?.breakdown)
                this.reviewsBreakdown.push(reviewsResponseData.breakdown)
            } else {
              // ELSE ENQUEUE QUERY PROMISES
              queryPromises.push(
                new Promise((resolve, reject) => {
                  this.$axios
                    .post('/api/judgeme/widget/productReviews', {
                      productId,
                      page: this.page,
                    })
                    .then(({ data }) => {
                      const parsedData = parseWidget(data.widget, productId)
                      this.$redisClient.setHash(
                        `jdgme-reviews:${this.productSlug}`,
                        productId,
                        JSON.stringify(parsedData),
                        ONE_DAY
                      )
                      resolve(parsedData)
                    })
                })
              )
            }
          }
        }

        // REVIEWS QUERY PROMISES
        if (queryPromises?.length) {
          Promise.all(queryPromises).then((reviewsData) => {
            for (const { breakdown, reviews } of reviewsData) {
              if (reviews?.length) this.reviewsResults.push(...reviews)
              if (breakdown?.totalReviews > 0) {
                this.reviewsBreakdown.push(breakdown)
              }
            }
          })
        }
      } catch (error) {
        this.$sentryException(error, {
          source: 'product page',
          level: 'warning',
          extra: `Failed to get product reviews: ${error}`,
        })
      }
    },
    sortReviewsBy(sortBy) {
      this.reviewsSortBy = sortBy
    },
    loadNextReviewPage() {
      this.reviewPage++
    },
    handleScroll() {
      const mainAtf = this.$refs['main-atf']
      if (window.scrollY >= mainAtf?.clientHeight - 300) {
        this.showCarousels = true
      }
    },
  },
}
